import React from 'react'
import { ListItem } from '@material-ui/core'
import Link from 'ui/Link'

export default ({
  selected,
  className,
  handleClick,
  to,
  onLinkClick,
  children,
}) => {
  const additionalProps = to
    ? { component: Link, to, onClick: onLinkClick }
    : { button: true, onClick: handleClick }

  return (
    <ListItem selected={selected} className={className} {...additionalProps}>
      {children}
    </ListItem>
  )
}
